module.exports = __webpack_public_path__ + "img/default-btn-ms.5e46cad0.png";